import React from "react";

const InputType = ({ name, value, onChange, options }) => {
  const handleChange = (val) => {
    var e = {
      target: {
        value: val || "",
        name: name,
      },
    };
    onChange(e);
  };

  return (
    <div
      className={`grid gap-4 ${
        options.length === 1
          ? "grid-cols-1"
          : options.length === 2
          ? "grid-cols-1 sm:grid-cols-2"
          : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
      }`}
    >
      {options.map((item, ind) => (
        <button
          key={ind}
          onClick={() => handleChange(item.id)}
          className={`w-full h-full text-left p-3 border rounded-xl transition flex justify-start items-start
        ${
          item.id === value
            ? "bg-gray-100 shadow-md !border-primary !border-2"
            : "border-gray-300 hover:!border-primary"
        }`}
        >
          <div className="grid w-full">
            <div className="pb-1">
              <span className="text-[20px] font-medium">{item.label}</span>
            </div>
            <div className="mb-5 border-b border-gray-300" />
            <div className="text-[14px]">
              <span>{item.subtitle}</span>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default InputType;
